/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M8 9l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M16 15l-4 4l-4 -4", "key": "svg-1" }]];
const IconSelector = createReactComponent("outline", "selector", "Selector", __iconNode);

export { __iconNode, IconSelector as default };
//# sourceMappingURL=IconSelector.mjs.map
